import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    details: [],
    agentRecipients: []
  },
  getters: {
    details: state => state.details,
    agentRecipients: state => state.agentRecipients
  },
  actions: {
    fetchAgentRecipients({ commit }, ids) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "/Shipping/api/RecipientsQuery/ownerUser/" +
              ids.ownerUserId +
              "/recipient-of-agent/" +
              ids.agentId
          )
          .then(r => {
            commit("setAgentRecipients", r.data);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    fetchAgentWhoHasMembersRecipients({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "/Shipping/api/RecipientsQuery/ownerUser/" + id + "/all-recipients"
          )
          .then(r => {
            commit("setAgentRecipients", r.data);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    addAgentRecipients({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Shipping/api/Recipients", model)
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    },
    update({ commit, dispatch }, model) {
      return ajax.put("Shipping/api/Recipients", model).then(() => {});
    }
  },
  mutations: {
    setAgentRecipients(state, data) {
      state.agentRecipients = data;
    },
    setDetails(state, data) {
      state.details = data;
    }
  }
};
